













































































































































































































/* eslint-disable  @typescript-eslint/no-explicit-any */

import {
  toRefs,
  ref,
  reactive,
  computed,
  defineComponent
} from "@vue/composition-api";
import { useMainStore } from "@/store/storage";
import { db } from "../firebase/firebase";
import { Locations } from "@/interfaces/interfaces";
import draggable from "vuedraggable";

export default defineComponent({
  components: {
    draggable
  },
  props: {},
  setup(props, { root }) {
    interface VForm extends HTMLFormElement {
      validate(): boolean;
    }

    const main = useMainStore();
    const locationform = ref(null);
    const formElement = (locationform.value as unknown) as VForm;

    const state = reactive({
      page: root.$route.params.page,
      valid: false,
      showform: true,
      showmessage: false,
      showProgress: false,
      message: "",
      messageClass: "success",
      id: "",
      order: 10,
      location: "",
      locations: [],
      draggedId: "",
      draggedIndex: 0,
      relatedDraggedId: "",
      relatedDraggedIndex: 0,
      relatedDraggedItem: "",
      relatedDraggedList: [] as Locations[],
      loading: false,
      Listitem: 0,
      ordered: false,
      //TESTING FIT TEXT
      width: 100,
      height: 100,
      characters: 1,
      textString: "In a country of blind"
    });

    /* 
//testing fit text
 */

    const size = computed(() => {
      const len = state.textString.length;
      const height = state.height;
      const width = state.width;

      const calculate = (width *2) / len;

      console.log(width, height);
      return ( calculate * 30) + "%";
    });

    interface VForm extends HTMLFormElement {
      validate(): boolean;
    }

    function resetForm(): void {
      console.log("form element", formElement);
      // console.log(formElement.validate());
      state.id = "";
      state.location = "";
      formElement?.reset();
      formElement?.resetValidation();
      state.order = 10;
    }

    function hideMessage() {
      setTimeout(() => {
        state.showmessage = false;
        state.showProgress = false;
      }, 3000);
    }

    function save() {
      const locationformtyped = (locationform.value as unknown) as VForm;
      if (state.valid) {
        // const order = new Date().valueOf();
        const data = {
          order: state.order,
          location: state.location
        };

        if (!!state.id as boolean) {
          db.collection("locations")
            .doc(state.id)
            .update(data)
            .then(() => {
              state.message = "Location name successfully updated";
              state.messageClass = "success";
              state.showProgress = false;
              state.showmessage = true;
              locationformtyped.reset();
              locationformtyped.resetValidation();

              hideMessage();
            })
            .catch(() => {
              state.showProgress = false;
              state.message = "Something was wrong with the location name";
              state.messageClass = "error";
              state.showmessage = true;
              hideMessage();
            });
        }
        if (!state.id as boolean) {
          state.valid = false;
          state.showProgress = true;

          db.collection("locations")
            .add(data)
            .then(() => {
              state.message = "Location name saved successfully";
              state.messageClass = "success";
              state.showProgress = false;
              state.showmessage = true;
              locationformtyped.reset();
              locationformtyped.resetValidation();

              hideMessage();
            })
            .catch(() => {
              state.showProgress = false;
              state.message = "Something was wrong with the location name";
              state.messageClass = "error";
              state.showmessage = true;
              hideMessage();
            });
        }
      }
    }

    function editItem(item: Locations): void {
      state.id = item.id as string;
      state.order = item.order;
      state.location = item.location;
      state.showform = true;

      root.$vuetify.goTo("#comeHere");
    }

    function deleteItem(): void {
      if (state.id && confirm("Are you sure you want to delete this?")) {
        db.collection("locations")
          .doc(state.id as string)
          .delete()
          .then(() => {
            resetForm();
            console.log("Location Deleted");
          });
      }
    }

    function saveLocationOrder(): void {
      state.loading = true;
      main.state.locations.forEach((item, index) => {
        // console.log(index, item);
        db.collection("locations")
          .doc(item.id as string)
          .update({
            order: index
          })
          .then(() => {
            // console.log(index);
            state.loading = false;
            state.ordered = false;
          })
          .catch(() => {
            state.loading = false;
          });
      });
    }

    function dragEnd() {
      state.ordered = true;
      state.loading = false;

      // console.log(JSON.stringify(main.state.locations, null, 2))

      // setTimeout(() => {

      // }, 500);
    }
    function dragMove(event: any) {
      state.draggedId = event.draggedContext.element.id;
      state.draggedIndex = event.draggedContext.futureIndex;

      state.relatedDraggedId = event.relatedContext.element.id;
      state.relatedDraggedList = event.relatedContext.list as Locations[];
      // console.log(event.draggedContext, event.relatedContext);
    }

    return {
      ...toRefs(state),
      save,
      locationform,
      main: main.state,
      editItem,
      deleteItem,
      resetForm,
      dragEnd,
      dragMove,
      saveLocationOrder,
      size
    };
  }
});
